"use client"

import { BadgeTurkishLira } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BadgeTurkishLiraIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BadgeTurkishLiraIcon = component(Icon)({ as: BadgeTurkishLira })
